<template>
  <section class='leaveStu'>
    
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.text" placeholder="订单号" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
     <!-- <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>发布通知</i-button>
      </ul> -->
      <ul class='conheadRight'>

        <RadioGroup v-model="cjType" type="button" button-style="solid" @on-change='switchType'>

          <Radio label="待发货"></Radio>
           <Radio label="已发货"></Radio>
        </RadioGroup>

      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'></tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
  </section>
</template>

<script>
  import getDates from '../utils/index'
  import tablePage from './tablePage'
  import bemodal from './formItemNoSch'
  export default {
    name: 'goodslist',
    components: {
      tablePage,
      bemodal,
    },
    data() {
      return {
        cjType:'待发货',
        smodal: false,
        reloadTmep: -1,
        initformData: [],
        formData: [
          ['order/getId.do', 'order/save.do', 'order/delete.do'],
          [{
              type: 'textarea',
              title: '商品清单',
              name: 'goodlists',
              model: ''
            },


            {
              type: 'input',
              title: '物流编号',
              name: 'shipno',
              model: '',
              block: true,
            },
            {
              type: 'select',
              title: '快递单位',
              name: 'shipcompany',
              model: '',
              children: [{
                  name: '申通',
                  value: '1'
                },
                {
                  name: '圆通',
                  value: '2'
                },
                {
                  name: '韵达',
                  value: '3'
                },
                {
                  name: '顺丰',
                  value: '4'
                },
                {
                  name: '中通',
                  value: '5'
                },
              ],
               block: true,
            },
            {
              type: 'input',
              title: '联系电话',
              name: 'phone',
              model: '',
              block: true,
            },
            {
              type: 'input',
              title: '收货人',
              name: 'xm',
              model: '',
              block: true,
            },
            {
              type: 'input',
              title: '地址',
              name: 'detial',
              model: '',

            },

            {
              type: 'hidden',
              children: [{
                name: 'guid',
                model: ''
              }]
            }
          ]
        ],
        queryData: ['order/getQueryList.do',
          [{
              title: '订单号',
              key: 'out_trade_no',
              width: 230,
              render: (h, params) => {
                var c = params.row
                var _state = c.paytype == 'score' ||   c.paytype == ''? '积分' :''
                var viewcnt = {
                    style: {
                      color: 'rgb(0, 201, 219)',
                      background: 'rgba(0, 201, 219, 0.1)',
                      padding: "2px 8px",
                      borderRadius: '7px',
                      fontSize: '11px',
                      display: 'inline-block',
                    }
                }
            
                if (_state) {
                  return  h('div',[
                           h('span',viewcnt, _state),    
                           h('span',{},c.out_trade_no),  
                           
                         ])                 
                } else {
                  return h('span', c.out_trade_no)
                }
              }
            },
            {
              title: '商品名称',
              key: 'goodList',
              render: (h, params) => {
                var c = params.row
                var html = ''
                if (c.goodList != null && c.goodList.length > 0) {

                  for (var item = 0; item < c.goodList.length; item++) {
                    var itemData = c.goodList[item];
                    html += itemData.goodname + "*" + itemData.num + "|";
                  }
                }
              
                return h('span',html)
              }
            },
            {
              title: '昵称',
              key: 'xm',
              width: 150,
              align: 'center',
              render: (h, params) => {
                
              
                return h('span',decodeURIComponent(params.row.xm))
              }
            },
            {
              title: '金额',
              key: 'amount',
              width: 100,
              align: 'center',
            },
            {
              title: '积分',
              key: 'wjscore',
              width: 90,
              align: 'center',
            },
            {
              title: '支付方式',
              key: 'paytype',
              width: 100,
              align: 'center',
            },
            {
              title: '订单时间',
              key: 'paytime',
              width: 150,
              align: 'center',
            },
            {
              title: '状态',
              key: 'shipstate',
              width: 90,
              align: 'center',
              render: (h, params) => {
                var c = params.row
                var that = this 
                if (c.shipno != null && c.shipno != '') {
                  var _state = c.paytype == 'score' ||   c.paytype == ''? '已核销' :'已发货'
                  return h('span', {
                    style: {
                      color: 'rgb(0, 201, 219)',
                      background: 'rgba(0, 201, 219, 0.1)',
                      padding: "2px 8px",
                      borderRadius: '7px',
                      fontSize: '11px',
                      display: 'inline-block',
                    }

                  },_state)
                } else {
                  var _state = c.paytype == 'score' ||   c.paytype == '' ? '核销' :'待发货'
                  if(_state == '核销'){
                    return h('span', {
                        style: {
                          color: 'rgb(0, 201, 219)',
                     
                          cursor:'pointer',
                          padding: "2px 8px",
                          borderRadius: '7px',
                          fontSize: '14px',
                          display: 'inline-block',
                          textDecoration:'underline'
                        },
                        on: {
                          click: () => {
                           
                            this.$Modal.confirm({
                              title: '提示',
                              content: '<p>是否确认核销订单：【'+c.out_trade_no+'】？</p>',
                              onOk: () => {
                                var param = {
                                  guid: c.guid,
                                  shipno: '自提',
                                  shipcompany:1,
                                }
                               
                               
                                this.axios.post('order/save', param).then(res => {
                                  if (res.success) {
                                    that.$Message.success(res.msg)
                                    that.searchData()
                                  } else {
                                    that.$Message.info(res.msg)
                                  }

                                })
                              },
                              onCancel: () => {

                              }
                            });
                          }
                        }

                      }, _state)
                  }else{
                    return h('span', {
                        style: {
                          color: "#ed4c78",
                          backgroundColor: "rgba(237,76,120,.1)",
                          padding: "2px 8px",
                          borderRadius: '7px',
                          fontSize: '11px',
                          display: 'inline-block',
                        }

                      }, _state)
                  }
                 
                }
              }
            },
            {
              title: '操作',
              slot: 'action',
              width: 90,
              align: 'center'
            }

          ]
        ],
        searchParam: {
          text: '',
          shipno:0,
        },
        issearch: -1,
      }
    },
    mounted() {
      this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    },
    methods: {
      switchType(e) {
        if (e == '待发货') {
          this.searchParam.shipno = 0
        } else if (e == '已发货') {
           this.searchParam.shipno = 1
        }
        this.searchData()
      },
      searchData() {
        const result = /^\d+$/.test(this.searchParam.text)
        console.log(result)
        // if(result){
        //   this.searchParam.phone = this.searchParam.text
        //   this.searchParam.xm = ''
        //   this.searchParam.out_trade_no = ''
        // }else{
        //   if(this.searchParam.text.length<10){
        //       this.searchParam.phone = ''
        //       this.searchParam.out_trade_no = ''
             this.searchParam.xm  =this.searchParam.text
        //   }else{
        //      this.searchParam.phone = ''
        //      this.searchParam.xm  = ''
        //      this.searchParam.out_trade_no = this.searchParam.text
        //   }
         
        // }
				this.issearch = Math.random()
       
      },
      sModal(guid) {
      
        this.reloadTmep = Math.random()
        if (this.formData[0][0].indexOf('?') > -1) {
          this.formData[0][0] = this.formData[0][0].split('?')[0]
        }
        this.formData[0][0] = this.formData[0][0] + '?id=' + guid
        if (guid == -1) {
          this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
        }
      },
      reloadTable() {
        this.issearch = Math.random()
      }
    }
  }
</script>

<style scoped>
  .tabelContent {
    margin-top: 20px;
  }

  .leaveStu {
    flex: 1;
    padding-right: 25px !important;
    /* overflow: scroll; */
    padding-bottom: 50px;
    padding-top: 20px;
    overflow-x: hidden;
  }

  .leaveStu .ivu-row:first-of-type {
    margin-top: 5px;
  }

  .leaveStu .ivu-row {
    margin-top: 20px;
    /* 	overflow:hidden; */
    position: relative;
  }

  .leaveStu .ivu-col {
    margin-right: 10px;
    /* float:left; */
  }

  .leaveStu .ivu-col:last-of-type {
    float: left;
    margin-left: 10px;
    /* position:absolute;
		right:0px; */
  }

  .demo-upload-list {



    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    overflow: hidden;
    margin-right: 4px;
    margin-bottom: 5px;
  }

  .demo-upload-list img {
    width: 40px;
    height: 40px;
    float: left;
    margin-right: 15px;
  }

  .demo-upload-list span {
    line-height: 40px;
    font-size: 12px;
    float: left;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 10px;
    line-height: 40px;

  }

  #hwSchool {
    position: relative;
  }

  #hwSchool .ivu-tree {
    position: absolute;
    top: 33px;
    left: 0px;
    background: #fff;
    z-index: 1000;
    width: 300px;
    height: 300px;
    border: 1px solid #dcdee2;
    border-top: 0 none;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-left: 10px;
  }

  .modalUl {
    width: 100%;
    display: flex;
    justify-content: space-between;


  }

  .modalUl li {
    list-style: none;

  }

  .modalUl>li:first-of-type {
    width: 35%;
    height: 100%;
    height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .modalUl>li:last-of-type {
    flex: 1;
    padding-left: 30px;
  }

  .treeContent {}

  .hwImgCon {
    margin-top: 10px;

  }

  .hwImgCon img {
    width: 55px;
    height: 55px;
    border-radius: 5px;
  }

  .conheadRight {
    float: right;
  }
</style>
